export default {
  translation: {
    DATA_SHARING_PROTOCALL: 'Data Sharing Protocol',
    DOWNLOAD_PDF: 'Download PDF',
  }
}